import VehicleComponentPane from "./VehicleComponentPane";

export default VehicleComponentPane;
export { VehicleComponentPane };
